import React from 'react';
import {classes} from './PaymentRequestItem.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {ItemLayout} from '../../../../common/components/Item/ItemLayout';
import {ItemName} from '../../../../common/components/Item/ItemName/ItemName';
import {ItemPrice} from '../../../../common/components/Item/ItemPrice/ItemPrice';
import {ItemImage, Thumbnail} from '../../../../common/components/Item/ItemImage/ItemImage';
import {useControllerProps} from '../../Widget/ControllerContext';
import {DetailLine} from '../../../../common/components/Item/ItemDetails/DetailLine';
import {trimToMaxLength} from '../../../../domain/utils/trimToMaxLength';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../common/constants';

export enum PaymentRequestItemDataHooks {
  LineItemWrapper = 'PaymentRequestItemDataHooks.LineItemWrapper',
  title = 'PaymentRequestItemDataHooks.title',
  Price = 'PaymentRequestItemDataHooks.Price',
  description = 'PaymentRequestItemDataHooks.description',
  Image = 'PaymentRequestItemDataHooks.Image',
  DefaultImage = 'PaymentRequestItemDataHooks.DefaultImage',
}

export const PaymentRequestItem = ({useLayoutForLongPrice}: {useLayoutForLongPrice: boolean}) => {
  const localeKeys = useLocaleKeys();
  const {
    paymentRequestStore: {paymentRequest},
  } = useControllerProps();
  const thumbnail: Thumbnail | undefined = paymentRequest.image
    ? {
        src: paymentRequest.image.src,
        height: paymentRequest.image.height,
        width: paymentRequest.image.width,
        altText: paymentRequest.image.altText,
      }
    : undefined;
  const {experiments} = useExperiments();
  const HideMissingLineItemImagesInPaymentRequest = experiments.enabled(
    SPECS.HideMissingLineItemImagesInPaymentRequest
  );

  return (
    <li data-hook={PaymentRequestItemDataHooks.LineItemWrapper}>
      <ItemLayout
        descriptionWithColumns={!useLayoutForLongPrice}
        Icon={
          !HideMissingLineItemImagesInPaymentRequest || thumbnail ? (
            <ItemImage
              defaultImageDataHook={PaymentRequestItemDataHooks.DefaultImage}
              thumbnail={thumbnail}
              imageDataHook={PaymentRequestItemDataHooks.Image}
            />
          ) : null
        }
        MainDescription={<ItemName name={paymentRequest.title} dataHook={PaymentRequestItemDataHooks.title} />}
        SecondaryDescription={
          <ItemPrice
            priceDataHook={PaymentRequestItemDataHooks.Price}
            shortPrice={!useLayoutForLongPrice}
            formattedPrice={paymentRequest.total.formattedAmount}
            priceAriaLabel={localeKeys.checkout.orderSummary.price.ariaLabel({
              price: paymentRequest.total.formattedAmount,
            })}
          />
        }
        Details={
          <div className={classes.itemData}>
            <DetailLine
              dataHook={PaymentRequestItemDataHooks.description}
              value={trimToMaxLength(paymentRequest.description)}
            />
          </div>
        }
      />
    </li>
  );
};
